import { parseBloomreachContent, parseBloomreachMeta, getCommonParams } from "../helpers/hooks/helpers/helpers.js";
function useBloomreachData({
  page,
  component
}) {
  const { document: documentRef } = component.getModels();
  const document = documentRef && page.getContent(documentRef);
  const content = {
    ...page.isPreview() ? { document } : {},
    ...parseBloomreachContent(document?.getData())
  };
  const meta = parseBloomreachMeta(component.getParameters());
  const common = getCommonParams(meta);
  return {
    ref: documentRef?.$ref,
    data: {
      meta,
      content,
      ...common
    }
  };
}
export {
  useBloomreachData
};
//# sourceMappingURL=use-bloomreach-data.js.map
